<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="interactions-message-transcripts-section" v-loading="loading">
    <div class="interactions-div-message-transcripts-viewer-header" v-if="messagesTranscripts && messagesTranscripts.length > 0">
      <div class="header">
        <span class="title">
          Transcript
        </span>
        <div class="right-section">
          <!-- save transcript -->
          <div v-if="selectedMessage">
            <el-tooltip v-if="selectedMessage.isSavedTranscript" ref="unSaveTooltip" class="save-item" content="Unsave transcript" effect="dark" placement="bottom">
              <div :class="isTranscriptSummaryEnabled ? '' : 'summary-icon-hidden'">
                <el-button v-if="selectedMessage.isSavedTranscript" slot="reference" class="saved-transcript-golden-star" @click="removeSavedTranscript($event, selectedMessage)"></el-button>
              </div>
            </el-tooltip>
            <el-tooltip v-if="!selectedMessage.isSavedTranscript" ref="saveTooltip" class="save-item" content="Save transcript" effect="dark" placement="bottom">
              <div :class="isTranscriptSummaryEnabled ? '' : 'summary-icon-hidden'">
                <el-button v-if="!selectedMessage.isSavedTranscript" slot="reference" class="saved-transcript-grey-star" @click="addSavedTranscript($event, selectedMessage)"></el-button>
              </div>
            </el-tooltip>
          </div>

          <!-- summary -->
          <!-- Show summary -->
          <el-tooltip v-show="isTranscriptSummaryEnabled && !showTranscriptSummary" ref="summaryTooltip" :content="'View summary'" effect="dark" placement="bottom">
            <el-button class="summary-icon" @click="handleShowSummary(selectedMessage)"></el-button>
          </el-tooltip>
          <el-tooltip v-show="isTranscriptSummaryEnabled && showTranscriptSummary" ref="summaryTooltip" :content="'Hide summary'" effect="dark" placement="bottom">
            <el-button class="summary-icon" @click="handleHideSummary()"></el-button>
          </el-tooltip>

          <wy-interactions-panel-header-transcript-info :transcript="selectedMessage" />

          <el-tooltip v-if="isRoleAllow(4602)" ref="mediaPlayerTooltip" :content="'Media player'" effect="dark" placement="bottom">
            <el-button class="media-player-icon" @click="handleOpenMediaPlayer(selectedMessage)"></el-button>
          </el-tooltip>
          
        </div>
      </div>
    </div>
    <div class="interactions-div-message-transcripts-viewer-content" v-if="messagesTranscripts && messagesTranscripts.length > 0">
      <div class="transcriptSummary" v-if="showTranscriptSummary && !transcriptSummaryError" v-loading="transcriptSummaryLoading">
        <div v-if="selectedMessage.contentSummary" class="title">
          <div class="summaryTitle"></div>
          Transcript Summary
        </div>
        <div v-if="selectedMessage.contentSummary" class="summary" v-html="contentSummary"></div>
        <div v-if="selectedMessage.contentSummary" class="footer">[ Generated by AI ]</div>
      </div>
      <div v-else-if="transcriptSummaryError" class="transcriptSummaryError">
        <div class="content">
          <div class="info">
            <el-button class="errorIcon" @click="handleHideSummary"></el-button>
            <div class="body">
              <div>Summary failed to load.</div>
              <el-button class="tryAgainBtn" @click="handleShowSummary(selectedMessage)">Try again</el-button>
            </div>
          </div>
          <el-button class="closeIcon" @click="handleHideSummary"></el-button>
        </div>
      </div>
      <div
        v-for="(transcript, index) in messagesTranscripts"
        :key="index"
        style="display: flex; flex-direction: column;"
        class="div-message-transcript-name"
        :class="{
          'div-message-transcript-name-highlighted': transcript.text == selectedMessage.messageText,
          'cus-style': transcript.sentBy == 'U',
          'agent-style': transcript.sentBy == 'A',
        }"
      >
        <div class="div-sent-by">
          {{ toTranscriptLabel(transcript.sentBy) }}, <span class="time-stamp-style">{{ handleTimeFormat(transcript.datetime) }}</span>
        </div>
        &nbsp;
        <div v-if="transcript && transcript.text.includes('||')" v-html="transcript.text.replace(/\|\|+/g, ' | ')" class="div-transcript-text-double-line"></div>
        <div v-else-if="transcript && transcript.text.includes('|')" v-html="transcript.text" class="div-transcript-text-double-line"></div>
        <div v-else v-html="transcript.text" class="div-transcript-text"></div>
      </div>
    </div>
    <div v-else-if="!loading && !messagesTranscripts" class="interactions-div-message-transcripts-viewer-content-empty" >
      This Grouped Topic doesn’t contain any contacts that appear within the current filters. Change the Date Range or Organization filters to see the contacts within this topic.
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import WyUtils from '../../../library/wy-utils.js';
import wyPanelHeaderTranscriptInfo from '../widgets/wy-interactions-panel-header-transcript-info.vue';

export default Vue.extend({
  name: 'wy-interactions-transcript-viewer',
  props: ['parent', 'messagesTranscripts', 'selectedMessage', 'loading', 'viewName', 'fromConfiguration'],
  components: {
    'wy-interactions-panel-header-transcript-info': wyPanelHeaderTranscriptInfo,
  },

  data() {
    return {
      showTranscriptSummary: false,
      transcriptSummaryLoading: false,
      transcriptSummaryError: false,
    };
  },
  computed: {
    ...mapGetters(['companyConfig', 'isRoleAllow', 'isC1Auth', 'tokenInfo']),
    isTranscriptSummaryEnabled() {
      return false;
      // if(this.isC1Auth) {
      //   return this.isRoleAllow(900007);
      // }
      // else {
      //   return (this.companyConfig ? this.companyConfig.enableTranscriptSummary : false);
      // }
    },
    contentSummary() {
      return this.selectedMessage.contentSummary;
    },
    isMessagesTranscriptsEmpty() {
      return !this.selectedMessage
    },
  },
  watch: {
    selectedMessage: {
      handler: function(val, oldVal) {
        if (val && val.conversationId && oldVal && oldVal.conversationId) {
          if (val.conversationId === oldVal.conversationId) {
            return;
          }
          this.showTranscriptSummary = false;
          this.transcriptSummaryError = false;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['addTranscript', 'removeTranscript', 'fetchTranscriptSummary']),

    getAmplitudeWhere() {
      const sectionName = this.fromConfiguration ? 'Configuration' : 'Conversation Analytics';
      const pageName = this.fromConfiguration ? 'Database' : 'Conversation Topics';
      const viewName = this.fromConfiguration ? this.viewName : `Conversation Topics Individual - ${this.viewName}`;

      return  {
        section: sectionName,
        page: pageName,
        view: viewName,
        full_path: `${sectionName} | ${pageName} | ${viewName}`,
      }
    },

    async handleShowSummary(transcript) {
      this.showTranscriptSummary = true;
      this.transcriptSummaryError = false;
      this.transcriptSummaryLoading = true;

      // if exists in session storage, return data from session storage
      const sessionData = sessionStorage.getItem(transcript.conversationId);
      if (sessionData || transcript.contentSummary) {
        const summary = sessionData ? JSON.parse(sessionData).summary : transcript.contentSummary;
        this.transcriptSummaryLoading = false;
        transcript.contentSummary =
          '<ul>' +
          summary
            .replace(/-/g, '')
            .split('\n')
            .map(function(item) {
              return '<li>' + item.trim() + '</li>';
            })
            .join('') +
          '</ul>';
        return;
      }

      // else fetch from network
      const contentSummary = await this.fetchTranscriptSummary({
        conversationId: transcript.conversationId,
      });
      this.transcriptSummaryLoading = false;

      if (contentSummary.status == 200 && (contentSummary.data && contentSummary.data.summary)) {
        transcript.contentSummary =
          '<ul>' +
          contentSummary.data.summary
            .replace(/-/g, '')
            .split('\n')
            .map(function(item) {
              return '<li>' + item.trim() + '</li>';
            })
            .join('') +
          '</ul>';
        sessionStorage.setItem(transcript.conversationId, JSON.stringify(contentSummary.data));
        return;
      }
      this.transcriptSummaryError = true;
    },

    handleHideSummary() {
      this.showTranscriptSummary = false;
      this.transcriptSummaryError = false;
    },

    handleOpenMediaPlayer(transcript) {
      if(this.tokenInfo && this.tokenInfo.authHost) {
        const mediaLink = `https://${this.tokenInfo.authHost}/#/recordings/${transcript.conversationId}/ccr/player`
        window.open(mediaLink);
      }
    },

    formatHeaderDate(date) {
      return WyUtils.formatDateWithDay(date);
    },
    formatHeaderTimeRange(transcript) {
      return WyUtils.getTimeRange(transcript);
    },
    formatInfoHandleTime(Millis) {
      let seconds = Millis / 1000;
      return WyUtils.toNiceTimeFormat(seconds);
    },
    toTranscriptLabel(key) {
      key = key.toUpperCase();
      let map = {
        "U": "Customer",
        "USER": "Customer",
        "CLIENT": "Customer",
        "B": "Virtual Agent",
        "BOT": "Virtual Agent",
        "CUSTOMER": "Customer",
        "CONSUMER": "Customer",
        "AGENT": "Agent",
        "A": "Agent",
        "T": "Agent",
        "C": "Customer",
        "S": "System",
        "SYSTEM": "System",
      }  
      if(map[key]) {
        return map[key];
      }
      return key;
    },
    handleTimeFormat(datetime) {
      return moment(datetime).format('h:mm:ss a');
    },
    async removeSavedTranscript(e, transcript) {
      e.stopPropagation();

      let result = await this.removeTranscript({
        conversationId: transcript.conversationId,
        where: this.getAmplitudeWhere()
      });
      if (result && result.status && result.status == 200) {
        this.selectedMessage.isSavedTranscript = false;
        this.$forceUpdate();
      }
      // Tooltip display/hide
      if (this.$refs.saveTooltip && this.$refs.unSaveTooltip) {
        this.$refs.unSaveTooltip.$el.style.display = 'none';
        this.$refs.saveTooltip.$el.style.display = 'block';
      }
    },
    async addSavedTranscript(e, transcript) {
      e.stopPropagation();

      let result = await this.addTranscript({
        conversationId: transcript.conversationId,
        where: this.getAmplitudeWhere()
      });
      if (result && result.status && result.status == 200) {
        this.selectedMessage.isSavedTranscript = true;
        this.$forceUpdate();
      }
      // Tooltip display/hide
      if (this.$refs.saveTooltip && this.$refs.unSaveTooltip) {
        this.$refs.saveTooltip.$el.style.display = 'none';
        this.$refs.unSaveTooltip.$el.style.display = 'block';
      }
    },
  },
});
</script>

<style lang="scss">
.interactions-message-transcripts-section {
  width: 677px;
  // max-width: 677px;
  flex: 1;
  padding: 5px 0px 17px 0px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e8e8e8;
  border-left: 0px;
  border-radius: 0px 10px 10px 0px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-end;

  .el-loading-mask {
    background-color: white;
  }

  ul {
    margin-top: -4px;
  }

  ul,
  li {
    list-style-type: disc !important;
    list-style-position: inside !important;
    padding: 4px 0px 0px 0px !important;
    text-indent: -1.5em !important;
    margin-left: 1.5em !important;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
    font-size: 14.22px !important;
  }

  .header {
    display: flex;
    position: relative;
    bottom: 3px;
    justify-content: space-between;

    .title {
      display: flex;
      gap: 8px;
    }
  }

  .interactions-div-message-transcripts-viewer-header {
    font-size: 16px;
    border-bottom: 1px solid #e8e8e8;
    font-weight: 500;
    padding: 10px 10px 0px 30px;
    width: 100%;
    box-sizing: border-box;
    display: inline-block;

    .right-section {
      width: 111px;
      display: flex;
      position: relative;
      bottom: 5px;
      justify-content: space-around;
    }

    .sentiment-icon-positive {
      cursor: default;
      background-image: url('../../../assets/icons/icon_positive_senti.svg');
      background-size: 80%;
      background-repeat: no-repeat;
      background-position-y: 1px;
      background-position-x: 0px;
      position: relative;
      left: 0px;
      border-radius: 100px;
      border: 0px;
      top: 0px;
      margin: 0px 4px 0 0;
      padding: 12px 10px 14px 14px;
      float: left;
    }

    .sentiment-icon-neutral {
      cursor: default;
      background-image: url('../../../assets/icons/icon_neutral_senti.svg');
      background-size: 80%;
      background-repeat: no-repeat;
      background-position-y: 1px;
      background-position-x: 0px;
      position: relative;
      left: 0px;
      border-radius: 100px;
      border: 0px;
      top: 0px;
      margin: 0px 4px 0 0;
      padding: 12px 10px 14px 14px;
      float: left;
    }

    .sentiment-icon-negative {
      cursor: default;
      background-image: url('../../../assets/icons/icon_negative_senti.svg');
      background-size: 80%;
      background-repeat: no-repeat;
      background-position-y: 1px;
      background-position-x: 0px;
      position: relative;
      left: 0px;
      border-radius: 100px;
      border: 0px;
      top: 0px;
      margin: 0px 4px 0 0;
      padding: 12px 10px 14px 14px;
      float: left;
    }

    .summary-icon {
      background-image: url('../../../assets/icons/summary_icon.svg');
      background-size: 75%;
      background-repeat: no-repeat;
      background-position-y: 8px;
      background-position-x: 3px;
      position: relative;
      left: 7px;
      border: 0px;
      top: 0px;
      margin: -1px 13px 0 0;
      padding: 12px 10px 18px 14px;
      float: left;
    }

    .summary-icon-hidden {
      margin-left: 36px;
    }

    .media-player-icon {
      background-image: url('../../../assets/icons/icon_open_conversation.svg');
      background-size: 65%;
      background-repeat: no-repeat;
      background-position-y: 5px;
      background-position-x: 3px;
      position: relative;
      border: 0px;
      top: 2px;
      left: -4px;
      margin: -1px 13px 0 0;
      padding: 12px 10px 18px 14px;
      float: left;
      // make the color
      color: #4b5158;
      opacity: 0.65;
    }

    .saved-transcript-golden-star {
      background-image: url('../../../assets/icons/icon_golden_star.svg');
      margin: 0px;
      margin-top: 6px;
      margin-right: 6px;
      border: 0;
      height: 20px;
      width: 20px;
      background-repeat: no-repeat;
      padding: 0px;
    }

    .saved-transcript-grey-star {
      background-image: url('../../../assets/icons/icon_grey_star.svg');
      margin: 0px;
      margin-top: 6px;
      margin-right: 6px;
      border: 0;
      height: 20px;
      width: 20px;
      background-repeat: no-repeat;
      padding: 0px;
    }

    .el-button:hover,
    .el-button:visited,
    .el-button:focus {
      background-color: unset !important;
      color: none !important;
    }

    .date {
      font-size: 14px;
      font-weight: 400;
      line-height: 1.7;
      position: relative;
      top: -1px;
    }

    .time-range {
      font-size: 14px;
      font-weight: 400;
      line-height: 1.7;
    }
  }

  .interactions-div-message-transcripts-viewer-content {
    margin-top: 1px;
    //border-top: 1px solid #e8e8e8;
    height: calc(100vh - 372px);
    overflow-y: auto;
    overflow-x: hidden;
    margin-bottom: -14px;
    width: 100%;
    padding-bottom: 10px;

    .div-message-transcript-name.cus-style {
      background-color: #f8f6f6;
      margin: 10px 10px;
      border-bottom: unset !important;
    }

    .div-message-transcript-name.bot-style {
      background-color: #effcff;
      margin: 10px 10px;
      border-bottom: unset !important;
    }

    .div-message-transcript-name.agent-style {
      background-color: #effcff;
      margin: 10px 10px;
      border-bottom: unset !important;
    }

    .div-message-transcript-name {
      display: flex;
      padding: 10px 10px 9px 30px;
      border-bottom: 1px #e8e8e8 solid;
      // min-width: 442px;
      // width: 95%;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0px;
      cursor: default;

      .div-sent-by {
        font-weight: bold;
        font-size: 14.22px;
        padding-right: 10px;
        color: #000;

        span.time-stamp-style {
          color: #4b5158;
          font-size: 14.22px;
          font-weight: 400;
          font-weight: 400;
        }
      }

      .div-transcript-text {
        word-break: break-word;
        min-width: 365px;
        padding-right: 11px;
        padding-top: 1px;
        font-size: 14.22px;
        color: var(--site-font-secondary-color);
      }
    }

    // .div-message-transcript-name:hover {
    //   background-color: #f5f7fa;
    // }
    .div-message-transcript-name-highlighted {
      background-color: #e2ecf7;
    }

    .transcriptSummary {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin: 6px 0px;
      padding: 24px;
      border-bottom: 1px solid #e5e5e5;
      min-height: 150px;

      .title {
        font-weight: bold;
        font-size: 14px;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;

        .summaryTitle {
          background-image: url('../../../assets/icons/summary_title_icon.svg');
          background-size: 80%;
          background-repeat: no-repeat;
          background-position-y: 3px;
          background-position-x: 5px;
          position: relative;
          left: 7px;
          border-radius: 100px;
          border: 0px;
          top: 0px;
          margin: -3px 16px 0 0;
          padding: 12px 10px 18px 14px;
          float: left;
          color: var(--site-font-tertiary-color);
        }
      }

      .summary {
        color: rgb(75, 75, 75);
        margin-top: 12px;
      }

      .footer {
        margin-top: 14px;
        display: flex;
        justify-content: flex-end;
        width: 100%;
        color: #8c8c8c;
        font-size: 12px;
      }
    }

    .transcriptSummaryError {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 6px 10px;
      padding: 6px 40px 30px 40px;
      border-bottom: 1px solid #e5e5e5;
      min-height: 150px;

      .content {
        display: flex;
        width: 100%;
        justify-content: space-between;
        padding: 20px;
        border: 1px solid #ebafba;

        .info {
          display: flex;
          gap: 24px;
          font-weight: 500;
          font-size: 14.22px;

          .body {
            display: flex;
            flex-direction: column;
            font-weight: 600;
            gap: 16px;
          }

          .el-button {
            padding: 7px 15px 21px 10px;
          }

          .tryAgainBtn {
            border-radius: 4px;
            max-width: 100px;
            max-height: 35px;
            font-size: 16px;
            color: #202223;
            font-weight: 400;
            border: 1px solid #ebafba;
            display: flex;
            justify-content: center;
            height: 100%;

            &:hover {
              background-color: #f4f6f8;
            }
          }
        }

        .errorIcon {
          background-image: url('../../../assets/icons/icon_error_square.svg');
          height: 12px;
          width: 12px;
          background-repeat: no-repeat;
          background-position-y: 0px;
          background-position-x: 3px;
          margin-bottom: 8px;
          padding: 12px;
          border: none;
          cursor: default;

          &:hover {
            background-color: unset;
          }
        }

        .closeIcon {
          background-image: url('../../../assets/icons/icon_customer_close.svg');
          height: 12px;
          width: 12px;
          background-repeat: no-repeat;
          background-position-y: 6px;
          background-position-x: 6px;
          margin-bottom: 8px;
          padding: 12px;
          border: none;
          cursor: pointer;

          &:hover {
            background-color: transparent;
          }
        }
      }
    }

    &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 2px solid transparent;
      border-top: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background:#F3F6F8;
      border-top: 1px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track:vertical {
      // border-left: 1px solid #CAD2DA;
      border-top: none !important;
      border-bottom-right-radius: 12px;
    }
  }

  .interactions-div-message-transcripts-viewer-content-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 60%;
    font-size: 18px;
    color: #444D54;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
}
</style>
